import React from 'react';
import { StyleProp, View, ViewStyle } from 'react-native';
import { TextInput as PaperTextInput } from 'react-native-paper';

type PaperTextInputProps = React.ComponentProps<typeof PaperTextInput>;

type StylusTextInputProps = Omit<
  PaperTextInputProps,
  | 'label'
  | 'value'
  | 'onChangeText'
  | 'mode'
  | 'multiline'
  | 'numberOfLines'
  | 'disabled'
  | 'error'
  | 'placeholder'
  | 'secureTextEntry'
  | 'keyboardType'
  | 'autoCapitalize'
  | 'autoCorrect'
  | 'style'
  | 'right'
  | 'ref'
> & {
  label?: PaperTextInputProps['label'];
  value: string;
  onChangeText: NonNullable<PaperTextInputProps['onChangeText']>;
  mode?: PaperTextInputProps['mode'];
  multiline?: boolean;
  numberOfLines?: number;
  disabled?: boolean;
  error?: boolean;
  placeholder?: string;
  secureTextEntry?: boolean;
  keyboardType?: PaperTextInputProps['keyboardType'];
  autoCapitalize?: PaperTextInputProps['autoCapitalize'];
  autoCorrect?: boolean;
  style?: StyleProp<ViewStyle>;
};

const StylusTextInput: React.FC<StylusTextInputProps> = ({
  label,
  value,
  onChangeText,
  mode = 'outlined',
  multiline = false,
  numberOfLines = 1,
  disabled = false,
  error = false,
  placeholder,
  secureTextEntry = false,
  keyboardType = 'default',
  autoCapitalize = 'sentences',
  autoCorrect = true,
  style,
  ...otherProps
}) => {
  // On web, just render a regular PaperTextInput without stylus functionality
  return (
    <View style={style}>
      <PaperTextInput
        label={label}
        value={value}
        onChangeText={onChangeText}
        mode={mode}
        multiline={multiline}
        numberOfLines={numberOfLines}
        disabled={disabled}
        error={error}
        placeholder={placeholder}
        secureTextEntry={secureTextEntry}
        keyboardType={keyboardType}
        autoCapitalize={autoCapitalize}
        autoCorrect={autoCorrect}
        {...otherProps}
      />
    </View>
  );
};

export default StylusTextInput;
